import { render } from "react-dom";
import { ShareButton } from "./ShareButton";

(() => {
  const textHeadings = document.querySelectorAll(".share-heading h3");

  textHeadings.forEach((heading) => {
    const buttonContainer = document.createElement("div");

    buttonContainer.classList.add("heading-share-button");

    heading.appendChild(buttonContainer);

    if (!heading.textContent) return;

    render(<ShareButton shareText={heading.textContent} />, buttonContainer);
  });
})();
